import { Routes, Route, Navigate } from 'react-router-dom';
import routes from 'routes';
import { Box, useColorModeValue } from '@chakra-ui/react';
import SignInCentered from 'views/auth/signIn/SignInCentered';

// Chakra imports
import { SidebarContext } from 'contexts/SidebarContext';

// Custom Chakra theme
export default function Auth() {
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route, key) => {
      if (route.layout === '/auth') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse && route.items) {
        return getRoutes(route.items);
      }
      return null;
    }).filter(Boolean);
  };
  
  const authBg = useColorModeValue('background.100', 'background.900');
  document.documentElement.dir = 'ltr';
  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar: false,
          setToggleSidebar: () => {},
        }}
      >
        <Box
          bg={authBg}
          float="right"
          minHeight="100vh"
          height="100%"
          position="relative"
          w="100%"
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Box mx="auto" minH="100vh">
            <Routes>
              {getRoutes(routes)}
              <Route path="sign-in" element={<SignInCentered />} />
              <Route path="*" element={<Navigate to="sign-in" replace />} />
            </Routes>
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
